import { PaymentMethod } from '@cms-max/medicare-api-sdk'
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'makeAPaymentPage',
  keyPrefix: 'payYourPremium.form'
}

export const createSchema = (t: TFunction) => {
  return z
    .object({
      paymentMethod: z.enum([PaymentMethod.Ach, PaymentMethod.Cc, PaymentMethod.Hsa], {
        required_error: t('paymentMethod.validation', tConfig),
        invalid_type_error: t('paymentMethod.validation', tConfig)
      }),

      amount: z
        .string({
          required_error: t('amount.validation', tConfig)
        })
        .refine((value) => /^([0-9]+([.][0-9]{2})){0,1}$/.test(value.toString()), t('amount.validation', tConfig))
        .refine((value) => parseFloat(value) >= 10, t('amount.validation', tConfig))
        .refine((value) => parseFloat(value) <= 15000, t('amount.validation', tConfig))
    })
}

export type MakeAPaymentFormData = z.infer<ReturnType<typeof createSchema>>
